import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { SCOUTING_CENTER_OWNED_CARDS_RARITIES } from '@sorare/marketplace/src/lib/scoutingCenterFilters';
import type { FullProps } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import { BackendAdvancedPlayerSearch } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';
import { scoutingCenterBackendMarketDropdownFilters } from '@sorare/marketplace/src/searchCommonPlayer/filtersGroup/football';

type Props = Omit<FullProps, 'sport' | 'dropdownFilters'>;

export const FootballPlayerSearch = (props: Props) => (
  <BackendAdvancedPlayerSearch
    sport={Sport.FOOTBALL}
    defaultHitsPerPage={20}
    lastOwnedCardsRarities={SCOUTING_CENTER_OWNED_CARDS_RARITIES}
    {...props}
    dropdownFilters={scoutingCenterBackendMarketDropdownFilters}
  />
);
